<!-- expense-report.component.html -->
<mat-sidenav-container class="sidenav-container">
    <mat-sidenav mode="side" opened>
      <mat-nav-list>
        <mat-list-item *ngFor="let item of menuItems" (click)="activeTab(item.label)" [style]="selected===item.label?('    background-color: #00a990ee;color:#ffffff'):''">
          <mat-icon style="padding-top: 4px;"  matListIcon>{{ item.icon }}</mat-icon>
          <span matLine>{{ item.label }}</span>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>
  
   

    <mat-sidenav-content *ngIf="selected==='Home'">
        <div class="main-content">
          <h1>Home</h1>
  
          <!-- Pending Tasks Section -->
          <div class="row">
          <mat-card class=" col-md-4 pending-tasks-card">
            <mat-card-title>Pending Tasks</mat-card-title>
            <mat-divider></mat-divider>

            <mat-card-content>
              <div class="task-item">
                <div class="col-md-7 task-item">
                <mat-icon color="warn">error_outline</mat-icon>
                <span>Pending Approval</span>
            </div>
                <span class="col-md-5 task-item" class="task-count">0</span>
              </div>
              <mat-divider></mat-divider>
              <div class="task-item">
                <div class="col-md-7 task-item">

                <mat-icon>receipt</mat-icon>
                <span>Unreported Expenses</span></div>
                <span class="task-count">0</span>
              </div>
              <div  class=" task-item">
                <div class="col-md-7 task-item">

                <mat-icon>account_balance_wallet</mat-icon>
                <span>Unreported Advances</span></div>

                <span class="col-md-5 task-amount">₹0.00</span>
              </div>
            </mat-card-content>
          </mat-card>
  
          <!-- Quick Add Section -->
          <mat-card class=" col-md-8 quick-add-card">
            <mat-card-content class="d-flex justify-content-center">
              <input hidden  accept=".xlsx, .xls"  #fileInput type="file"> 

              <div class="quick-add-option shadow" (click)="fileInput.click()">
                <mat-icon color="primary">upload</mat-icon>
                <p><a >click here to attach</a></p>
              </div>

              <div class="quick-add-option shadow" (click)="onClickExpense()">
                <mat-icon color="primary">add</mat-icon>
                <p>Create Expense</p>
              </div>
              <div class="quick-add-option shadow" (click)="showDialog()">
                <mat-icon color="primary">folder</mat-icon>
                <p>Create Report</p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
          <!-- Reports Summary Section -->
          <mat-card class="reports-summary-card">
            <mat-card-title>Reports Summary</mat-card-title>
            <mat-tab-group>
              <mat-tab label="Most Recent Reports">
                <div class="report-details">
                    <div class="report-item">
                      <mat-icon></mat-icon>
                      <span style="padding-right: 100px;"> Report Details </span>
                    </div>
                    <div class="report-item">Total</div>
                    <div class="report-item">Status</div>
                  </div>  
                <div *ngFor="let report of reportList" class="report-details">
                    <div class="report-item" style="cursor: pointer;width: 280px;" (click)="rowReportClick(report)">
                      <mat-icon style="padding-right:8px ;">folder</mat-icon>
                      <span >{{report?.reportName}} -{{report?.reportUid}} {{formatDate(report?.genTs)}}  </span>
                      
                      <!-- <span></span> -->
                    </div>
                    <div class="report-total">₹0.00</div>
                    <div class="report-status">{{report?.status}}</div>
                  </div>            
            </mat-tab>
              <mat-tab label="Unsubmitted Reports">
                <div *ngFor="let report of reportList" class="report-details">
                  <div class="report-item" style="cursor: pointer;width: 280px;" (click)="rowReportClick(report)">
                    <mat-icon style="padding-right:8px ;">folder</mat-icon>
                    <span >{{report?.reportName}} -{{report?.reportUid}} {{formatDate(report?.genTs)}}  </span>
                    
                    <!-- <span></span> -->
                  </div>
                  <div class="report-total">₹0.00</div>
                  <div class="report-status">{{report?.status}}</div>
                </div>  
                </mat-tab>
              <mat-tab label="Awaiting Approval"></mat-tab>
              <mat-tab label="Awaiting Reimbursement"></mat-tab>
            </mat-tab-group>
           
          </mat-card>
        </div>
      </mat-sidenav-content>


 <mat-sidenav-content *ngIf="selected==='Reports'" class="main-content">
      <!-- <h3>ER-00001 </h3>
      <p>accounts - ER-00001 14/11/2024</p>
      <p>Total: ₹12,485.36 &nbsp; | &nbsp; Amount to be Reimbursed: ₹12,485.36</p>
  
      <div class="warning">
        <mat-icon color="warn">error_outline</mat-icon>
        Warning Violations - Uncategorized
      </div> -->
  
      <mat-tab-group>
        <mat-tab >
            <ng-template mat-tab-label>
                EXPENSES&nbsp;<span [matBadge]="1" matBadgeSize="medium" matBadgeOverlap="false"> </span>
              </ng-template> 
          <div class="upload-area">
            <input hidden  accept=".xlsx, .xls"  #fileBInput type="file"> 

            <button mat-raised-button color="primary" (click)="fileBInput.click()">Upload Receipt</button>
          </div>
  
          <!-- <table mat-table [dataSource]="expenses" class="mat-elevation-z8">
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef> Date </th>
              <td mat-cell *matCellDef="let expense"> {{ expense.date }} </td>
            </ng-container>
  
            <ng-container matColumnDef="vendor">
              <th mat-header-cell *matHeaderCellDef> Vendor </th>
              <td mat-cell *matCellDef="let expense"> {{ expense.vendor }} </td>
            </ng-container>
  
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef> Category </th>
              <td mat-cell *matCellDef="let expense"> {{ expense.category }} </td>
            </ng-container>
  
            <ng-container matColumnDef="reference">
              <th mat-header-cell *matHeaderCellDef> Reference </th>
              <td mat-cell *matCellDef="let expense"> {{ expense.reference }} </td>
            </ng-container>
  
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef> Amount </th>
              <td mat-cell *matCellDef="let expense"> ₹{{ expense.amount | number:'1.2-2' }} </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="['date', 'vendor', 'category', 'reference', 'amount']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['date', 'vendor', 'category', 'reference', 'amount'];"></tr>
          </table> -->

          <div class="report-details">
            <div class="report-item">
              <mat-icon></mat-icon>
              <span style="padding-right: 100px;"> Report Details </span>
            </div>
            <div class="report-item">Total</div>
            <div class="report-item">Status</div>
          </div>  
        <div *ngFor="let report of reportList" class="report-details">
            <div class="report-item" style="cursor: pointer;width: 280px;" (click)="rowReportClick(report)">
              <mat-icon style="padding-right:8px ;">folder</mat-icon>
              <span >{{report?.reportName}} -{{report?.reportUid}} {{formatDate(report?.genTs)}}  </span>
              
              <!-- <span></span> -->
            </div>
            <div class="report-total">₹0.00</div>
            <div class="report-status">{{report?.status}}</div>
          </div> 

        </mat-tab>
  
        <mat-tab label="ADVANCES & REFUNDS">
          Advances & Refunds content here
        </mat-tab>
        
        <mat-tab label="HISTORY">
          History content here
        </mat-tab>
      </mat-tab-group>
    </mat-sidenav-content>

    <mat-sidenav-content *ngIf="selected==='Expenses'" class="main-content">

        <div class="d-flex justify-content-start mt-4">
            <h2 style="margin-right: 10px;">Report</h2>
            <mat-form-field appearance="outline">
                <mat-label>Report</mat-label>
                
                <mat-select [(ngModel)]="selectedReport"  (selectionChange)="getExpenseList()"> 
                  <mat-option *ngFor="let item of reportList" [value]="item?.reportUid">{{item?.reportName}}</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- <button mat-icon-button (click)="closePopup()">
                <mat-icon>close</mat-icon>
            </button> -->
              <button mat-flat-button style="color: #00a991;" (click)="openPopup()">+ Add  Expenses</button>

        </div>
<div class="col-md-12"  style="width: 100%;" >

  
        <table mat-table [dataSource]="expenseList" >
            <!-- Index Column -->
            <ng-container matColumnDef="index">
                <th mat-header-cell *matHeaderCellDef> # </th>
                <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
            </ng-container>

            <!-- Expense Date Column -->
            <ng-container matColumnDef="expenseDate">
                <th mat-header-cell *matHeaderCellDef> Expense Date * </th>
                <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowExpenseClick(element)">
{{element?.expenseDate}}
                </td>
            </ng-container>

            <!-- Merchant Column -->
            <ng-container matColumnDef="merchant">
                <th mat-header-cell *matHeaderCellDef> Merchant </th>
                <td mat-cell *matCellDef="let element">
{{element?.merchant}}
                </td>
            </ng-container>

            <!-- Category Column -->
            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef> Category * </th>
                <td mat-cell *matCellDef="let element">{{element?.category}}
                </td>
            </ng-container>

            <!-- Amount Column -->
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef> Amount * </th>
                <td mat-cell *matCellDef="let element">
                   {{element?.amount}}
                </td>
            </ng-container>

            <!-- Reimbursable Column -->
            <ng-container matColumnDef="reimbursable">
                <th mat-header-cell *matHeaderCellDef>  </th>
                <td mat-cell *matCellDef="let element">
                  {{element.reimburasble}}
                </td>
            </ng-container>

            <!-- Description Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let element">

                    <input matInput  class="form-control" [(ngModel)]="element.description">
                </td>
            </ng-container>

            <!-- Reference Column -->
            <ng-container matColumnDef="reference">
                <th mat-header-cell *matHeaderCellDef> Reference# </th>
                <td mat-cell *matCellDef="let element">

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
            <tr class="mat-row" *matNoDataRow>
                <td  class="mat-cell" colspan="4">There is no data in this table</td>
                </tr>
        </table>
        <div *ngIf="expenseList.length>0" class="d-flex justify-content-end mt-3">
        <button  mat-flat-button style="color: #00a991;width: 250px;"  (click)="sendApproval()"> Submit</button>
      </div>
    </div>


    </mat-sidenav-content>
    <mat-sidenav-content *ngIf="selected==='Approvals'">
      <app-approver-dashboard></app-approver-dashboard>
</mat-sidenav-content>
  </mat-sidenav-container>



  <div>

    <p-dialog
  [(visible)]="displayDialog"
  [header]="action!='update'?('New Report'):'View Report'"
  [style]="{ width: '450px' }"
  [closable]="true"
  [dismissableMask]="true"
>
  <div class="info-box">
    <p><strong>Note:</strong> A report will be created every month automatically and you can submit it for approval. Next report creation is on: <strong>02/12/2024</strong></p>
  </div>

  <div class="form-field">
    <label>Report Name *</label>
    <input type="text" [(ngModel)]="reportRequest.reportName" pInputText   />
  </div>

  <div class="form-field">
    <label>Business Purpose</label>
    <textarea pInputTextarea rows="3" [(ngModel)]="reportRequest.businessPurpose" placeholder="Max 500 characters"></textarea>
  </div>

  <div class="form-field duration">
    <label>Duration *</label>
    <input type="date" class="form-control" [(ngModel)]="reportRequest.fromDate"  pInputText placeholder="eg: 31/01/2020" />
    <input type="date" class="form-control" [(ngModel)]="reportRequest.toDate" pInputText placeholder="eg: 31/01/2020" />
  </div>

  <div class="form-field">
    <label>Trip *</label>
    <select [(ngModel)]="reportRequest.tripId">
        <option [value]="tripResponse?.tripUid">{{tripResponse?.tripName}}</option>
    </select>
  </div>

  <p-footer>
    <button *ngIf="action!='update'" pButton label="Save"  icon="pi pi-check" class="p-button-success" (click)="AddReport()" [disabled]="disableReport()"></button>
    <button pButton label="Cancel" icon="pi pi-times" class="p-button-secondary" (click)="cancel()"></button>
  </p-footer>
</p-dialog>

  </div>
  

  <div class="popup-overlay" *ngIf="isOpen">
    <div class="popup-content">
        <div class="popup-header">
          <mat-form-field class="mt-2" appearance="outline">
            <mat-label>Report</mat-label>
            <mat-select [(ngModel)]="expenseRequest.reportId">
                <mat-option *ngFor="let item of reportList" [value]="item?.reportUid">{{item?.reportName}}</mat-option>
            </mat-select>
        </mat-form-field>
          <button mat-icon-button (click)="closePopup()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="col-md-12">

      <div class="info-box">
        <div class="upload-area">
          <input hidden  accept=".xlsx, .xls"  #fileEInput type="file"> 

          <button mat-raised-button color="primary" (click)="fileEInput.click()">Upload Receipt</button>
        </div>
        <!-- <p><strong>Note:</strong> A report will be created every month automatically and you can submit it for approval. Next report creation is on: <strong>02/12/2024</strong></p> -->
      </div>
    
      <div class="form-field " >
        <label>Expense Date *</label>
        <input type="date" class="form-control" [(ngModel)]="expenseRequest.expenseDate" pInputText   />

      </div>
      
      <div class="form-field duration mt-4" >
        <label>Amount *</label>
        <input type="text" (keypress)="onlyNumberKey($event)" class="form-control" [(ngModel)]="expenseRequest.amount" pInputText   />
        
        <mat-checkbox color="primary" [(ngModel)]="expenseRequest.reimburasble" checked>Reimbursable</mat-checkbox>


      </div>
    
      
    
      <div class="form-field ">
        <label>Merchant *</label>
        <input type="text"  [(ngModel)]="expenseRequest.merchant"  pInputText  />
      </div>
      <div class="form-field">
        <label>Description</label>
        <textarea pInputTextarea rows="3" [(ngModel)]="expenseRequest.description" ></textarea>
      </div>
      <div class="form-field ">
        <label>Reference</label>
        <input type="text"  [(ngModel)]="expenseRequest.reference"  pInputText  />
      </div>
      <div class="form-field">
        <label>Category *</label>
        <mat-select class="form-control" [(ngModel)]="expenseRequest.category">
            <mat-option class="mat-primary" *ngFor="let item of categoryList" [value]="item">{{item}}</mat-option>
           
        </mat-select>
      </div>
    </div>
    <div *ngIf="actionE==='new'" class="d-flex justify-content-end mt-2">

        <button mat-raised-button color="primary" (click)="AddExpense()" [disabled]="disableExpanse()"> Add  Expense</button>
    </div>
      </div>
</div>
